import { render, staticRenderFns } from "./Digitalization.vue?vue&type=template&id=22e2d005&"
import script from "./Digitalization.vue?vue&type=script&lang=ts&"
export * from "./Digitalization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports